import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const faqModule = {
  namespaced: true,
  state: {
    faqs: null,
    faq: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default faqModule;
